import { render } from "./YoutubeBlock.vue?vue&type=template&id=e22b4eb4&ts=true"
import script from "./YoutubeBlock.vue?vue&type=script&lang=ts"
export * from "./YoutubeBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__